import { Flex, Heading, Pill } from '@eleveo/components-react';
import React, { useMemo } from 'react';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { useIntegrations } from '../../../app/IntegrationsProvider';
import { TEST_IDS } from '../../../constants/dataTestIds';
import { ConfigurationType } from '../../../scene/integrations/types';
import { getPillConfig } from '../../../utils/configurationCardUtils';
import { getRootState } from '../../../utils/formUtils';

export const IntegrationTitle: React.FC = () => {
  const { t } = useTranslation();

  const { integrationType } = useIntegrations();

  const { values: formState } = useFormState<ConfigurationType>({ subscription: { values: true } });

  const { state } = getRootState(formState);
  const pillConfig = useMemo(
    () => getPillConfig(state, t),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  return (
    <Flex>
      <Heading as="h3" className="text-2xl text-blue-700 font-bold" testId={TEST_IDS.headingConfigurationTitle}>
        {t(`providers.${integrationType}`)}
      </Heading>
      {pillConfig && (
        <Pill
          color={pillConfig.color}
          variant={pillConfig.variant}
          className="mis-auto"
          testId={TEST_IDS.pillConfiguration}
        >
          {pillConfig.icon}
          {pillConfig.statusText}
        </Pill>
      )}
    </Flex>
  );
};
